import { type Tag } from '@hungryroot/rest';

export function getProductNeverTagName(
  tags: Tag[] | number[] | undefined,
  neveredTagIds: Set<number>
): string | null {
  if (!tags?.length || neveredTagIds.size === 0) {
    return null;
  }

  if (typeof tags[0] === 'number') {
    return null;
  }

  const neverTag = (tags as Tag[]).find((tag) => neveredTagIds.has(tag.id));

  return neverTag?.name ?? null;
}
